import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs } from 'wsm-common-data';
import Address from 'wsm-contact-address';
import ResultsHeading from './ResultsHeading';
import { ResultsContext } from '../../contexts';
import { g } from '../../global-constants';

const AddressCard = ({
	name,
	address1,
	city,
	state,
	postalCode,
	getDirectionsLabel,
	getDirectionsUrl,
	addressClasses,
	label,
	ariaLabelledById
}) => {
	const optionalAttributes = {
		...(label && { 'aria-labelledby': ariaLabelledById })
	};
	const { handleLinkClick } = useContext(ResultsContext);
	const { display } = usePrefs();
	const isPanelMode = display === g.NAVIGATION_DRAWER;
	const handleClick = () => {
		handleLinkClick('richContentLink', getDirectionsLabel, '');
	};
	// Panel mode drops .text-black here and on the icon below so both inherit
	// the card's own themed color instead of a fixed `black !important`.
	const addressElementClassName =
		setClassNames([
			...addressClasses.split(' '),
			!isPanelMode && 'text-black',
			'ddc-font-size-base',
			'my-3'
		]) || '';

	const cardClassName = setClassNames([
		'bg-location',
		isPanelMode ? 'sts-panel-card' : 'bg-neutral-0',
		'd-flex',
		'border',
		'p-4',
		// Panel mode's content wrapper already supplies the horizontal inset.
		!isPanelMode && 'mx-4',
		'mb-4'
	]);

	const iconClassName = setClassNames([
		'ddc-icon',
		'ddc-icon-map',
		'ddc-font-size-xlarge',
		!isPanelMode && 'text-black'
	]);

	return (
		<React.Fragment>
			{label && (
				<ResultsHeading
					label={label}
					ariaLabelledById={ariaLabelledById}
				/>
			)}
			<div
				{...optionalAttributes}
				data-testid="sts-address-card"
				className={cardClassName}
			>
				<div
					data-testid="sts-address-card-icon-wrapper"
					className={setClassNames([
						'd-sm-inline',
						!isPanelMode && 'mx-4'
					])}
				>
					<i
						data-testid="sts-address-card-icon"
						className={iconClassName}
						aria-hidden="true"
					/>
				</div>
				<Address
					name={name}
					address1={address1}
					city={city}
					state={state}
					postalCode={postalCode}
					url={{
						text: getDirectionsLabel,
						link: getDirectionsUrl
					}}
					addressClasses={addressElementClassName}
					onGetDirectionsClick={handleClick}
				/>
			</div>
		</React.Fragment>
	);
};
AddressCard.propTypes = {
	name: PropTypes.string.isRequired,
	address1: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	postalCode: PropTypes.string.isRequired,
	getDirectionsLabel: PropTypes.string.isRequired,
	getDirectionsUrl: PropTypes.string.isRequired,
	addressClasses: PropTypes.string,
	label: PropTypes.string,
	ariaLabelledById: PropTypes.string
};
AddressCard.defaultProps = {
	label: '',
	ariaLabelledById: 'address-card-0',
	addressClasses: ''
};
export default AddressCard;
